import { Layout, TextInput, PrimaryButton, ImageArea } from '../components'
import styled from 'styled-components'
import { useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { db, FirebaseTimestamp } from "../firebase"
import { push } from 'connected-react-router'
// mui
import Switch from '@material-ui/core/Switch'

const newsRef = db.collection('news')


const NewsEdit = () => {
    const dispatch = useDispatch()

    // URLからID取得
    let id = window.location.pathname.split('/news/edit')[1];
    if (id) { id = id.split('/')[1] }

    // 入力内容初期化
    const [image, setImage] = useState([])
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [metaTitle, setMetaTitle] = useState('')
    const [metaDescription, setMetaDescription] = useState('')
    const [metaKeywords, setMetaKeywords] = useState([])
    const [isDraft, setIsDraft] = useState(false)
    const [isTrash, setIsTrash] = useState(false)

    // ゴミ箱移動処理
    const moveToTrash = useCallback(()=>{
        return newsRef.doc(id).set({isTrash: true}, {merge: true})
                      .then(() => {dispatch(push('/admin/news'))})
                      .catch( error => {throw new Error(error)})
    },[id, dispatch])
    const moveFromTrash = useCallback(()=>{
        return newsRef.doc(id).set({isTrash: false}, {merge: true})
                      .then(() => {dispatch(push('/admin/news'))})
                      .catch( error => {throw new Error(error)})
    },[id, dispatch])

    // 保存処理
    const saveNews = useCallback((id, image, title, text, metaTitle, metaDescription, metaKeywords, isDraft, isTrash) => {
        return async (dispatch) => {

            // Image Validation
            if (!image || image.length === 0) {
                alert('画像が設定されていません')
                return false
            }

            // Validation
            if (title === '' || text === '' ) {
                alert('未入力の必須項目があります')
                return false
            }

            const timestamp = FirebaseTimestamp.now()
            const data = {
                image, title, text, 
                metaTitle: metaTitle ? metaTitle : "",
                metaDescription: metaDescription ? metaDescription : "", 
                metaKeywords: metaKeywords ? metaKeywords : "",
                isDraft, isTrash,
                updated_at: timestamp,
            }
            
            // 新規作成の場合はidと作成日のデータをセット
            if (id === '') {
                const ref = newsRef.doc()
                id = ref.id
                data.id = id
                data.created_at = timestamp
            }
    
            // Firestoreに保存
            return newsRef.doc(id).set(data, {merge: true})
                .then(() => {
                    dispatch(push('/admin/news'))
                }).catch( error => {
                    throw new Error(error)
                })
        }
    },[])

    useEffect( () => {
        if (id) {
            newsRef.doc(id).get()
                   .then(snapshot => {
                        const data = snapshot.data()
                        setImage(data.image)
                        setTitle(data.title)
                        setText(data.text)
                        setMetaTitle(data.metaTitle)
                        setMetaDescription(data.metaDescription)
                        setMetaKeywords(data.metaKeywords)
                        setIsDraft(data.isDraft)
                        setIsTrash(data.isTrash)
                   })
        }
        return false
    }, [id]);

    return (
        <Layout>
            <div className='spacer-50'></div>
            <h2>ニュースの投稿・編集</h2>
            <div className='spacer-50'></div>

            <FormWrapper>
                <ImageArea image={image} setImage={setImage} />
                <TextInput 
                    fullWidth={true} label={'タイトル'} multiline={false} rows={1} required={true} type={'text'} 
                    value={title} onChange={e=>setTitle(e.target.value)}
                />
                <TextInput 
                    fullWidth={true} label={'本文'} multiline={true} rows={10} required={true} type={'text'} 
                    value={text} onChange={e=>setText(e.target.value)}
                />
                <div className='spacer-50' />
                <TextInput 
                    fullWidth={true} label={'titleメタデータ'} multiline={false} rows={1} type={'text'} 
                    value={metaTitle} onChange={e=>setMetaTitle(e.target.value)}
                />
                <TextInput 
                    fullWidth={true} label={'descriptionメタデータ'} multiline={true} rows={2} type={'text'} 
                    value={metaDescription} onChange={e=>setMetaDescription(e.target.value)}
                />
                <TextInput 
                    fullWidth={true} label={'keywordsメタデータ'} multiline={false} rows={1} type={'text'} 
                    value={metaKeywords} onChange={e=>setMetaKeywords(e.target.value)}
                />
                <div className='spacer-50' />
            </FormWrapper>

            <div className='spacer-50'></div>
            
            <ButtonWrapper>
                <SwitchWrapper>
                    <div>下書きとして保存</div>
                    <Switch
                        color="primary" checked={isDraft}
                        onChange={()=>setIsDraft(!isDraft)}
                    />
                </SwitchWrapper>
                <div className='spacer-25' />
                <PrimaryButton 
                    label={isDraft ? '下書きを保存する' : '公開する'} 
                    operation={ () => dispatch(saveNews(id,image,title,text, metaTitle, metaDescription, metaKeywords, isDraft, isTrash)) }
                />
                <div className='spacer-25' />
                {isTrash ? (
                    <button onClick={moveFromTrash}>ゴミ箱から戻す</button>
                ) : (
                    <button onClick={moveToTrash}>ゴミ箱に入れる</button>
                )}
                <div className='spacer-25' />
                <button onClick={()=> dispatch(push('/admin/news'))}>キャンセル</button>
            </ButtonWrapper>
            
            <div className='spacer-100'></div>
        </Layout>
    )
}

export default NewsEdit

const FormWrapper = styled.div`
    width: 480px;
    margin: 0 auto;
`
const ButtonWrapper = styled(FormWrapper)`
    text-align: center;
`
const SwitchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`